<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close">
    <template v-slot:modalHeader>
      <h2 class="flex items-center">
        <IconValidate20Green class="mr-1" />Procédure lancée avec succès !
      </h2>
    </template>
    <template v-slot:modalBody>
      <div class="mb-8">
        Un e-mail vous a été envoyé à l'adresse indiquée ci-dessous pour vous
        permettre de
        <strong>signer électroniquement</strong> votre
        {{
          props.type_contrat === 'Contrat' ? 'Contrat formateur' : 'avenant'
        }}.
        <br />
        Le lien contenu dans cet e-mail est valable pendant
        <strong>60 jours</strong>.
      </div>

      <div
        class="mb-8 flex w-full max-w-md items-start gap-3 rounded-lg border border-blue-100 bg-refonte-pale-violet-2 p-4 text-left">
        <div class="icon-email">
          <IconEmail />
        </div>
        <div>
          <div
            class="mb-0.5 text-xs font-semibold uppercase tracking-wide text-blue-600">
            Récapitulatif de vos coordonnées
          </div>
          <div class="text-sm font-bold">
            {{ props.formateur.nom }} {{ props.formateur.prenom }}
          </div>
          <div class="text-sm">{{ props.formateur.email }}</div>
          <div class="text-sm">
            {{ props.formateur.telephone }}
          </div>
        </div>
      </div>
    </template>
    <template v-slot:modalFooter>
      <refonte-button v-bind:on_click="props.on_close"> Fermer </refonte-button>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import IconValidate20Green from '@/assets/img/refonte/icons/information/icon-validate-20-green.svg?component';
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import IconEmail from '@/assets/img/refonte/icons/information/icon-email.svg?component';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import { InfoFormateurSignature } from '@/types/formateur/info-formateur-signature';
  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      title?: string;
      formateur: InfoFormateurSignature;
      type_contrat?: string;
      class?: string;
    }>(),
    {
      class: '',
      type_contrat: 'Contrat'
    }
  );
</script>

<style lang="scss" scoped>
  .icon-email {
    @apply flex shrink-0 items-center justify-center;
    width: 18px;
    height: 18px;

    :deep(svg) {
      @apply text-refonte_blue-600;
      width: 18px;
      height: 18px;
    }
  }
  .icon-phone {
    @apply flex shrink-0 items-center justify-center;
    width: 14px;
    height: 14px;

    :deep(svg) {
      @apply text-refonte_blue-600;
      width: 14px;
      height: 14px;
    }
  }
</style>
